import React, { createContext, Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import socketio from 'socket.io-client';
import moment from 'moment';

import Avatar from '@components/avatar';
import { Coffee, UploadCloud } from 'react-feather';

import { toast, Slide } from 'react-toastify';
import {
  getOrganizationData,
  getUserData,
  isUserLoggedIn,
  renderClient,
  toCapitalize
} from '../Utils';
//import { workingTaskListAction } from '../../views/contacts/employee/task-reporting/store/action';

import { BiNotification } from 'react-icons/bi';
import {
  getCommunityChatMessagesAction,
  getCommunityContactChatsAction,
  getCommunityGroupLiveChatHistoryAction,
  getCommunityMemberByCommunityIdAction,
  getCommunityMemberByContactIdIdAction,
  getCommunityOwnerAction,
  getCommunityOwnerChatsAction
} from '../../views/community/store/action';
import SoundNotification from '../../assets/sounds/client_message_sound.mp3';
import { setIsShowBubbleReducer, setIsShowDmBubbleReducer, setMemberDetailsReducer, setMembersReducer, setSelectedContactReducer } from '../../views/community/store/reducer';

const SOCKET_URL = process.env.REACT_APP_API?.slice(0, -1);
const location = JSON.parse(localStorage.getItem('location'));
const SocketContext = createContext();
const ToastContent = ({ name, email, role }) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <Avatar size="sm" color="success" icon={<BiNotification size={12} />} />
        <h6 className="toast-title fw-bold">Hi, {getUserData().fullName}</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>
        A customer is looking for supporter.
        <br />
        Name: <b>{name}</b>
        <br />
        Email: <b>{email}</b>
      </span>
    </div>
  </Fragment>
);

const UploadProofContent = ({ taskName, subTaskName, proofType, endDate, employeeInfo, photo }) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <Avatar size="sm" color="success" icon={<UploadCloud size={16} />} />
        <h6 className="toast-title fw-bold">Welcome, {getUserData().fullName}</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>
        <b>{employeeInfo.fullName}</b> has uploaded the {proofType} for the{' '}
        <strong>
          {taskName} / {subTaskName}
        </strong>
        .
        <br />
        Please check the task.
      </span>
      <div style={{ width: '100%' }}>
        <img
          src={photo}
          width="200px"
          style={{
            display: 'block',
            alignContent: 'center',
            borderRadius: '5px',
            marginTop: '20px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />
      </div>
    </div>
  </Fragment>
);

const NewTaskCreated = ({ taskName, startDate, endDate, employerInfo }) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <Avatar size="sm" color="success" icon={<UploadCloud size={16} />} />
        <h6 className="toast-title fw-bold">Welcome, {getUserData().fullName}</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>
        <b>{employerInfo.fullName}</b> created new task <strong>{taskName}</strong> for you.
        <br />
        Please check the task.
      </span>
    </div>
  </Fragment>
);

const CompleteTaskContent = ({ taskName, endDate, fullName }) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <Avatar size="sm" color="success" icon={<Coffee size={12} />} />
        <h6 className="toast-title fw-bold">Welcome, {name}</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>
        <b>{fullName}</b> has completed all tasks for <strong>{taskName}</strong> at{' '}
        {moment(endDate).format('MMMM Do YYYY, h:mm:ss A')}.
        <br />
        Please check the task.
      </span>
    </div>
  </Fragment>
);

const CommunityConnectContent = ({ userName, userAvatar, type }) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        {renderClient({ fullName: userName, size: 'md', photo: userAvatar })}
        <h6 className="toast-title fw-bold">{toCapitalize(type)} Community Connect</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>
        <b>{userName}</b> {type} to connect with you in Community
        <br />
        Please check the connection.
      </span>
    </div>
  </Fragment>
);
const NewCommunityChatToast = ({ message }) => (
  <Fragment>
    <div className="toastify-body">
      <span>{message}</span>
    </div>
  </Fragment>
);

const socket = socketio(SOCKET_URL);
// const socket = socketio('http://localhost:5000/api');

const SocketProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isShowDmBubble, isOpenDmBubbleChat, isOpenDmChat } = useSelector(
    (state) => state?.socialCommunity
  );

  useEffect(() => {
    socket.connect();
    socket.on('ready-client', () => {
      if (isUserLoggedIn()) {
        if (getOrganizationData()?._id) {
          socket.emit('orgRegister', getOrganizationData()._id);
          if(location){
            const payload = { 
              contactId: location?.contactId,
              userId: location?.assignerId,
              organizationId: location?.organizationId
            };
            socket.emit('contact-connect', payload);
          }
        } else {
          socket.emit('adminRegister', getUserData().id);
          socket.emit('getNotifications', getUserData().id);
          socket.emit('eventsNotification', getUserData().id);
          socket.emit('tasksNotification', getUserData().id);
          socket.emit('renewalNotification', getUserData().id);
          socket.emit('missYouCallNotification', getUserData().id);
          if (location) {
            const payload = {
              //userId:getUserData().id,
              contactId: location?.contactId,
              userId: location?.assignerId,
              organizationId: location?.organizationId
            };
            //socket.emit('signinCommunity', payload);
            console.log(location);
            socket.emit('typing', payload);
            socket.emit('contact-connect', payload);
            socket.emit("request-connected-contacts");
          }
        }
      }
    });

    socket.on('startChat', (data) => {
      toast.success(
        <ToastContent
          name={data?.userInfo.fullName || data?.userInfo.username || 'John Doe'}
          email={data?.userInfo.email}
          role={data.role || 'admin'}
        />,
        {
          icon: false,
          transition: Slide,
          hideProgressBar: true,
          autoClose: 2000,
          position: 'bottom-right'
        }
      );
    });
    // Task Reporting Notification
    socket.on('receiveWorkProof', (data) => {
      const { taskName, subTaskName, photo, proofType, startDate, endDate, employeeInfo } = data;
      toast.success(
        <UploadProofContent
          taskName={taskName}
          subTaskName={subTaskName}
          proofType={proofType}
          startDate={startDate}
          endDate={endDate}
          employeeInfo={employeeInfo}
          photo={photo}
        />,
        {
          icon: false,
          hideProgressBar: true,
          transition: Slide,
          autoClose: 4000,
          position: 'top-right'
        }
      );
    });

    // Task Submit
    socket.on('completeTask', (data) => {
      toast.success(
        <CompleteTaskContent
          taskName={data.taskName}
          endDate={data.endDate}
          fullName={data.assignee.label}
        />,
        {
          icon: false,
          hideProgressBar: true,
          transition: Slide,
          autoClose: 4000,
          position: 'top-right'
        }
      );
    });

    socket.on('newTask', (data) => {
      const { taskName, startDate, endDate, employerInfo } = data;
      //dispatch(workingTaskListAction(options));
      toast.success(
        <NewTaskCreated
          taskName={taskName}
          startDate={startDate}
          endDate={endDate}
          employerInfo={employerInfo}
        />,
        {
          icon: false,
          hideProgressBar: true,
          transition: Slide,
          autoClose: 4000,
          position: 'top-right'
        }
      );
    });

    socket.on('communityMessage', ({ message, contactId, isOwner }) => {
      toast.info(<NewCommunityChatToast message={message} />, {
        transition: Slide,
        hideProgressBar: true,
        autoClose: 2000,
        position: 'bottom-right'
      });
      console.log('communityMessage', contactId);
      if (isOwner) {
        dispatch(getCommunityOwnerChatsAction());
      } else {
        dispatch(getCommunityContactChatsAction(contactId));
      }
    });

      // Function to play notification sound
      const playNotificationSound = () => {
        const audio = new Audio(SoundNotification);
        audio.play().catch((error) => console.error('Error playing sound:', error));
      };

    socket.on('communityDMmessage', (data) => {
      const { message, contactId, isOwner, sender,receiver,communityId,
        conversationWithOwner } = data;      
        playNotificationSound();
      // toast.info(<NewCommunityChatToast message={message} />, {
      //   transition: Slide,
      //   hideProgressBar: true,
      //   autoClose: 2000,
      //   position: 'bottom-right'
      // });

       if (!isShowDmBubble) {
            dispatch(setIsShowDmBubbleReducer(true));
            dispatch(setIsShowBubbleReducer(false));
          }

          if(communityId){
            dispatch(getCommunityMemberByCommunityIdAction(communityId)).then((res)=>{
               dispatch(setMembersReducer(res))
            });
           }

       if(sender!== null && receiver!== null && communityId){
        const payload = {
          communityId: communityId,
          sender: sender,
          receiver: receiver,
        }
         dispatch(getCommunityChatMessagesAction(payload));
         dispatch(getCommunityMemberByContactIdIdAction({communityId: communityId, contactId: sender})).then((res)=>{
           dispatch(setMemberDetailsReducer(res))
           dispatch(setSelectedContactReducer(res?.contact))
          });
       }else if (isOwner && conversationWithOwner){
        const payload = {
          communityId: communityId,
          sender: sender,
          receiver: receiver,
          isOwner: isOwner,
          conversationWithOwner: conversationWithOwner
        }
        dispatch(getCommunityChatMessagesAction(payload));
        dispatch(getCommunityOwnerAction({userId: location?.assignerId, communityId, contactId: location?.contactId})).then((res)=> {
          dispatch(setMemberDetailsReducer(res))
          const updatedContact = { ...res, isOwner: isOwner};
          dispatch(setSelectedContactReducer(updatedContact))
        })
       }
    });

    // socket.on('communityConnect', (data) => {
    //   const toastType =
    //     data?.type === 'request' ? 'info' : data?.type === 'accept' ? 'success' : 'warning';
    //   toast[toastType](
    //     <CommunityConnectContent
    //       userName={data?.userName}
    //       userAvatar={data?.userAvatar}
    //       type={data?.type}
    //     />,
    //     {
    //       icon: false,
    //       hideProgressBar: true,
    //       transition: Slide,
    //       autoClose: 4000,
    //       position: 'top-right'
    //     }
    //   );
    // });

    return () => {
      socket.off('startChat');
      socket.off('ready-client');
      socket.off('receiveWorkProof');
      socket.off('completeTask');
      socket.off('newTask');
    };
  }, [socket]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

export { SocketProvider, SocketContext };
